var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBhutan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24-.003H0v16.005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.5 4.52V3.133h-2.64l-.203.202a2.31 2.31 0 00-.517 2.19c.082.57.097.788-.12.998-.218.21-.428.21-1.005.127a2.295 2.295 0 00-2.183.51 2.318 2.318 0 00-.517 2.19c.082.57.09.788-.12 1.005-.21.218-.435.203-1.005.12a4.132 4.132 0 00-.698-.067v1.387c.174.008.346.026.518.053.247.045.499.067.75.067.278-.001.553-.058.81-.165v1.11h2.085v-1.035h-1.043v-.697h.698v-1.043h-.555a4.606 4.606 0 00-.06-.937c-.083-.57-.098-.788.12-1.005.217-.218.427-.203 1.005-.12.523.12 1.07.09 1.575-.09v1.11h2.085V8h-1.043v-.697h.698V6.26h-.555a4.606 4.606 0 00-.06-.937 1.688 1.688 0 010-.803h1.98z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhutan);
export default __webpack_public_path__ + "static/media/Bhutan.9f4cfc85d908eba8c8d5fcd9d80760f0.svg";
export { ForwardRef as ReactComponent };